(() => {
  if (window.SCNavigationPath) return;

  function localURL(raw, base = window.location.href) {
    try {
      const url = new URL(raw, base);
      return url.origin === window.location.origin ? url : null;
    } catch {
      return null;
    }
  }

  function collectionRoute(raw = window.location.href) {
    const url = localURL(raw);
    if (!url) return null;
    const match = /^(.*?)\/collections\/([^/]+)(?:\/products\/([^/]+))?\/?$/.exec(url.pathname);
    if (!match) return null;
    try {
      return { url, prefix: match[1], handle: decodeURIComponent(match[2]), productHandle: match[3] || null };
    } catch {
      return null;
    }
  }

  function readMenu() {
    try {
      const data = JSON.parse(document.getElementById('ScNavigationData')?.textContent || '{}');
      return { links: Array.isArray(data.links) ? data.links : [], rootURL: data.rootURL || '/' };
    } catch {
      return { links: [], rootURL: '/' };
    }
  }

  function menuPaths() {
    const result = [];
    function visit(links, parents, depth) {
      if (depth > 3) return;
      for (const link of links) {
        const route = collectionRoute(link.url);
        const isCollection = link.type === 'collection_link' && route && link.handle === route.handle;
        const path = isCollection ? [...parents, { title: link.title, url: link.url, handle: link.handle }] : parents;
        if (isCollection && !path.slice(0, -1).some(node => node.handle === link.handle)) result.push(path);
        if (Array.isArray(link.links)) visit(link.links, path, depth + 1);
      }
    }
    visit(readMenu().links, [], 1);
    return result;
  }

  function pathForHandle(handle) {
    const matches = menuPaths().filter(path => path.at(-1)?.handle === handle);
    const unique = new Map(matches.map(path => [path.map(node => node.handle).join('/'), path]));
    return unique.size === 1 ? [...unique.values()][0] : [];
  }

  function localizedNodes(path) {
    const root = localURL(readMenu().rootURL);
    const prefix = root?.pathname.replace(/\/$/, '') || '';
    return path.map(node => {
      const url = localURL(node.url);
      if (url && prefix && url.pathname.startsWith('/collections/')) url.pathname = prefix + url.pathname;
      return { ...node, url: url ? url.pathname + url.search + url.hash : node.url };
    });
  }

  function productPath({ collectionHandles = [], fallbackHandle = '' } = {}, raw = window.location.href) {
    const memberships = new Set(collectionHandles);
    const route = collectionRoute(raw);
    if (route?.productHandle && memberships.has(route.handle)) {
      const branch = pathForHandle(route.handle);
      if (branch.length) return localizedNodes(branch);
    }
    if (!memberships.has(fallbackHandle)) return [];
    const fallback = pathForHandle(fallbackHandle).find(node => node.handle === fallbackHandle);
    return fallback ? localizedNodes([fallback]) : [];
  }

  function contextualProductURL(raw, collectionURL = window.location.href) {
    const context = collectionRoute(collectionURL);
    const target = localURL(raw);
    if (!context || context.productHandle || !target) return raw;
    const match = /\/products\/([^/]+)\/?$/.exec(target.pathname);
    if (!match) return raw;
    target.pathname = context.prefix + '/collections/' + encodeURIComponent(context.handle) + '/products/' + match[1];
    return target.pathname + target.search + target.hash;
  }

  function updateCollectionLinks(root) {
    if (!collectionRoute() || collectionRoute().productHandle) return;
    for (const card of root.querySelectorAll('product-card[data-product-url]')) {
      const next = contextualProductURL(card.dataset.productUrl);
      if (next !== card.dataset.productUrl) card.dataset.productUrl = next;
      if ('productUrl' in card && card.productUrl !== next) card.productUrl = next;
    }
    for (const link of root.querySelectorAll('a[href]')) {
      const old = link.getAttribute('href');
      const next = contextualProductURL(old);
      if (next !== old) link.setAttribute('href', next);
    }
    for (const swatch of root.querySelectorAll('product-card-swatches [data-href]')) {
      const old = swatch.getAttribute('data-href');
      const next = contextualProductURL(old);
      if (next !== old) swatch.setAttribute('data-href', next);
    }
  }

  const observers = new WeakMap();
  function connectCollectionRoots() {
    for (const root of document.querySelectorAll('[data-ref="main-collection"]')) {
      updateCollectionLinks(root);
      if (observers.has(root)) continue;
      const observer = new MutationObserver(() => updateCollectionLinks(root));
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'data-product-url', 'data-href'] });
      observers.set(root, observer);
    }
  }

  window.SCNavigationPath = Object.freeze({ productPath, pathForHandle, contextualProductURL, collectionRoute });
  document.dispatchEvent(new CustomEvent('sc:navigation-path-ready'));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectCollectionRoots, { once: true });
  else connectCollectionRoots();
  document.addEventListener('shopify:section:load', connectCollectionRoots);
})();

